import moment from "moment";

// Shared by the combined board and the move detail page so a move reads the same color everywhere.
export const OUTCOMES = ["attention", "hold", "ready", "tonight", "upcoming", "processed"];
export const DEFAULT_OUTCOMES = ["attention", "hold", "ready", "tonight", "upcoming"];
export const OUTCOME_META = {
  attention: { chip: "Needs attention", pill: "need attention", color: "#c62828", bg: "#fdeceb" },
  hold: { chip: "On hold", pill: "on hold", color: "#9a6400", bg: "#fbf1dc" },
  ready: { chip: "Bills tonight", pill: "bill tonight", color: "#5b43c9", bg: "#eeeafc" },
  tonight: { chip: "Runs tonight", pill: "tonight", color: "#0b7a5c", bg: "#e2f4ed" },
  upcoming: { chip: "Upcoming", pill: "upcoming", color: "#7b828c", bg: "#eef0f2" },
  processed: { chip: "Processed since yesterday", pill: "processed", color: "#467a2a", bg: "#e8f2e0" },
  // Only the detail page shows a deleted move; the board never does.
  deleted: { chip: "Deleted", pill: "deleted", color: "#5f6670", bg: "#eef0f2" },
};
export const TYPE_COLOR = { in: "#1769c4", out: "#c25700" };

// The batch runs at 2 AM Eastern Tuesday through Friday, so its next run (nextRun from the server) isn't always
// tonight. A server without the tonight flag runs nightly.
export const nextRunText = (nextRun) => (!nextRun || nextRun.tonight !== false
  ? "tonight"
  : moment(nextRun.date, "YYYY-MM-DD").format("ddd, MMM D"));

// An outcome's chip and pill words; the two for the next run name it.
export function outcomeChip(outcome, nextRun) {
  if (outcome === "ready") return `Bills ${nextRunText(nextRun)}`;
  if (outcome === "tonight") return `Runs ${nextRunText(nextRun)}`;
  return (OUTCOME_META[outcome] || OUTCOME_META.upcoming).chip;
}

export function outcomePill(outcome, nextRun) {
  const when = nextRunText(nextRun);
  if (outcome === "ready") return `bill ${when}`;
  if (outcome === "tonight") return when === "tonight" ? "tonight" : `run ${when}`;
  return (OUTCOME_META[outcome] || OUTCOME_META.upcoming).pill;
}
